import 'babel-polyfill'
import Vue from 'vue'
import router from './router'
import App from './App.vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import './assets/css/animate.css'
// Setiar el font loader
//import 'material-design-icons/iconfont/material-icons.css'
import VueAjaxSetup from './scripts/VueAjaxSetup'
import VueFormSetup from './scripts/VueFormSetup'
import VueGridSetup from './scripts/VueGridSetup'
import VueFormatsSetup from './scripts/VueFormatsSetup'
import VueProgressBar from 'vue-progressbar'
import './style.css'

// Plugins Setup
Vue.config.productionTip = false
Vue.config.devtools = false
Vue.use(Vuetify, {
    theme: {
        primary: "#009688",
        accent: "#009688",
        error: "#f44336",
        //Faltan estos colores
        secondary: "#333333",
        warning: "#c09853",
        info: "#a87ad",
        success: "#468847"
    }
})
Vue.use(VueAjaxSetup)
Vue.use(VueGridSetup)
Vue.use(VueFormSetup)
Vue.use(VueProgressBar, {
    color: '#2196F3',
    failedColor: '#FF5252',
    thickness: '5px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 300
    },
    autoRevert: true,
    location: 'top',
    inverse: false
})
Vue.use(VueFormatsSetup)

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<app/>'
})



// WEBPACK FOOTER //
// ./src/main.js